export enum TripPanelTab {
  Replays = 0,
  AimFor8 = 1,
}

export interface AimFor8Report {
  ecoRating: number;
  ecoRatingChange?: number;
  averageMinutesToOptimal: number;
  averageMinutesToOptimalChange?: number;
  emissionsSaved: number;
  emissionsSavedChange?: number;
  extraEmissions: number;
  homeElectricityEquivalent: number;
  aiAccuracy: number;
  aiAccuracyChange?: number;
  vesselReports: VesselPerformanceReport[];
}

export interface VesselPerformanceReport {
  mmsi: string;
  name?: string;
  ecoRating: number;
  ecoRatingChange?: number;
  averageMinutesToOptimal: number;
  extraEmissions: number;
}

export enum AimFor8View {
  Overview = 'overview',
  EcoRating = 'ecoRating',
  LeftTooLate = 'leftTooLate',
  EmissionsSaved = 'emissionsSaved',
  AiAccuracy = 'aiAccuracy',
}

export interface AimFor8CardProps {
  data: AimFor8Report;
}

export interface AimFor8OverviewDashboardProps extends AimFor8CardProps {
  onViewChange: (view: AimFor8View) => void;
}
